import EDHttp from '../utils/EDHttp';
import FileDownload from 'js-file-download';

import Auth from './auth';

export default {
  addNote: function (id, noteDetails, noteId= "") {
    return new Promise((resolve, reject) => {
      EDHttp.post(`/admin/users/notes/${id}/${noteId}`, noteDetails)
        .then(
          result => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject('Error');
          }
        )
        .catch(error => reject(error));
    });
  },
  updateNotePinStatus: async function (id, body, noteId) {
    try {
      const response = await EDHttp.patch(`/admin/users/notes/${id}/${noteId}`, body)
      return response.data.data
    } catch (error) {
      throw error.response.message
    }
  },
  deleteNote: function (id, note) {
    return new Promise((resolve, reject) => {
      EDHttp.delete(`/admin/users/notes/${id}/${note}`)
        .then(
          result => {
            if (result && !result.data.error) resolve(true);
            else reject('Error');
          },
          error => reject(error)
        )
        .catch(error => reject(error));
    });
  },
  readNote: function (id, note) {
    return new Promise((resolve, reject) => {
      EDHttp.put(`/admin/users/notes/${id}/${note}`)
        .then(
          result => {
            if (result && !result.data.error) resolve(true);
            else reject('Error');
          },
          error => reject(error)
        )
        .catch(error => reject(error));
    });
  },
  load: function (
    page = 0,
    status = 'all',
    search = '',
    sort = 'desc',
    filter = '',
    account_mgr_id = '',
    domain_id = '',
    activationMethod,
    form="",
    formStatus="",
    from="",
    to=""
  ) {
    return new Promise((resolve, reject) => {
      EDHttp.get(
        `/admin/users/${status}/${page}/${search}?sort=${sort}&status=${filter}&accountmanagers=${account_mgr_id}&domains=${domain_id}&method=${activationMethod.toLowerCase()}&form=${form}&formStatus=${formStatus}&from=${from}&to=${to}`
      )
        .then(
          result => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject('Error');
          },
          error => reject(error)
        )
        .catch(error => reject(error));
    });
  },
  get: function (id) {
    return new Promise((resolve, reject) => {
      EDHttp.get(`/user/${id}`)
        .then(
          result => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject('Error');
          },
          error => reject(error)
        )
        .catch(error => reject(error));
    });
  },
  delete: async function (id) {
    try {
      const result = await EDHttp.delete(`/user/${id}`);
      return result.data.data;
    } catch (error) {
      throw error.response.data.message;
    }
  },
  approve: async function (id) {
    try {
      const result = await EDHttp.put(`/api/v2/analysis/approve/${id}/${Auth.account.id}`);
      return result.data.data;
    } catch (error) {
      throw error;
    }
  },
  autoAssignForms: async function (id) {
    try {
      const result = await EDHttp.put(`/api/forms/auto-assign/form/auto/${id}`);
      return result.data.data;
    } catch (error) {
      throw error;
    }
  },
  updatePersonalInfo: function (
    id,
    firstname,
    lastname,
    dob,
    email,
    phone,
    address,
    domain,
    middle_name,
    accountManager,
    alias,
    last_update_by,
    secondary_email,
    code,
    employerKey,
    is2FAEnabled
  ) {
    return new Promise((resolve, reject) => {
      EDHttp.put(`/user/information/${id}`, {
        firstname,
        lastname,
        dob,
        email,
        phone,
        address,
        domain,
        middle_name,
        accountManager,
        alias,
        last_update_by,
        secondary_email,
        code,
        employerKey,
        is2FAEnabled
      })
        .then(
          result => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject('Error');
          },
          error => reject(error)
        )
        .catch(error => reject(error));
    });
  },
  updateMyStudentData: function (msdId, myStudentData) {
    return new Promise((resolve, reject) => {
      EDHttp.put(`/admin/myStudentData/${msdId}`, { myStudentData })
        .then(
          result => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject('Error');
          },
          error => reject(error)
        )
        .catch(error => reject(error));
    });
  },
  updateFinancialInfo: function (
    id,
    payload
  ) {
    return new Promise((resolve, reject) => {
      EDHttp.put(`/api/finances/update/${id}`, payload)
        .then(
          result => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject('Error');
          },
          error => reject(error)
        )
        .catch(error => reject(error));
    });
  },
  updateEmploymentInfo: function ({
    id,
    pslf,
    occupation,
    teacher_type,
    applied,
    tlf,
    payments,
    last_update_by,
    tepslf,
    total_companies_worked_for,
    years_of_experience,
    contribution,
  }
  ) {
    return new Promise((resolve, reject) => {
      EDHttp.put(`/admin/employment/${id}`, {
        pslf,
        occupation,
        teacher_type,
        applied,
        tlf,
        payments,
        last_update_by,
        tepslf,
        total_companies_worked_for,
        years_of_experience,
        contribution
      })
        .then(
          result => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject('Error');
          },
          error => reject(error)
        )
        .catch(error => reject(error));
    });
  },
  getMsdDetails: async function (file) {
    try {
      const response = await EDHttp.downloadFile(file);
      return response.data;
    } catch (error) {
      return error
    }
  },
  downloadReport: function (
    companies,
    memberships,
    status,
    loans,
    query
  ) {
    return new Promise((resolve, reject) => {
      EDHttp.post(`/crm/report?${query}`, {
        companies,
        memberships,
        status,
        loans
      })
        .then(
          response => {
            if (response.status == 200) {
              resolve(true);
            } else reject('Error');
          },
          error => reject(error)
        )
        .catch(error => reject(error));
    });
  },
  runAnalysis: function (id, includeContribution) {
    return new Promise((resolve, reject) => {
      EDHttp.post(`/api/v2/analysis/${id}`, { includeContribution })
        .then(
          result => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject('Error');
          },
          error => reject(error)
        )
        .catch(error => reject(error));
    });
  },
  uploadMyStudentData: function (id, formData) {
    return new Promise((resolve, reject) => {
      EDHttp.uploadFormData(
        `/api/mystudentdata/${id}/peoplejoy_update`,
        formData
      )
        .then(
          result => {
            if (result && !result.data.error) resolve(result.data.data);
            else reject('Error');
          },
          error => reject(error)
        )
        .catch(error => reject(error));
    });
  },
  archiveUser: async function (id, payload) {
    try {
      const result = await EDHttp.put(`/admin/archive/${id}`, payload);
      return result.data.data;
    } catch (error) {
      throw error.response.data.message;
    }
  },
  unArchiveUser: async function (id) {
    try {
      const result = await EDHttp.put(`/admin/unarchive/${id}`);
      return result.data.data;
    } catch (error) {
      throw error.response.data.message;
    }
  },

  downloadPSLFReport: async function (from, to) {
    try {
      const result = await EDHttp.get(`/crm/pslf-report?from=${from}&to=${to}`);
      const date = new Date();
      FileDownload(result.data,  `pslf-report-${date.getMonth() + 1}-${date.getDate()}.csv`);
    } catch(error) {
      throw error.response.data.message;
    }
  }
};
